import { render, staticRenderFns } from "./TabImageProductDetailPanel.vue?vue&type=template&id=c0ccedf6&scoped=true&"
import script from "./TabImageProductDetailPanel.vue?vue&type=script&lang=js&"
export * from "./TabImageProductDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./TabImageProductDetailPanel.vue?vue&type=style&index=0&id=c0ccedf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ccedf6",
  null
  
)

export default component.exports